import { Space } from 'antd';
import { FormattedMessage } from 'react-intl';

import { api } from '@/api';
import { DeleteAction, EditAction } from '@/components/table/actions';
import { PERMISSION_DELETE, PERMISSION_OBJ_CONTAINER, PERMISSION_UPDATE } from '@/constants/permissions';
import { withPermissions } from '@/hocs/permission';
import { containerStore } from '@/stores';
import { showError } from '@/utils/common';

const PermissionedEditAction = withPermissions([[PERMISSION_OBJ_CONTAINER, PERMISSION_UPDATE]])(EditAction);
const PermissionedDeleteAction = withPermissions([[PERMISSION_OBJ_CONTAINER, PERMISSION_DELETE]])(DeleteAction);

const Actions = (_: any, record: any) => {
  const onDelete = () => {
    api.containers
      .delete(record.id)
      .source.then(() => containerStore.deleteItem(record.id))
      .catch(showError);
  };

  return (
    <Space>
      <PermissionedEditAction uiSref={{ to: 'base-layout.containers.edit', params: { containerId: record.id } }} />
      <PermissionedDeleteAction onConfirm={onDelete} />
    </Space>
  );
};

export const columns = [
  {
    title: 'id',
    dataIndex: 'id',
    sorter: true,
  },
  {
    title: <FormattedMessage id={'containers.name'} />,
    dataIndex: 'name',
    sorter: true,
  },
  {
    title: <FormattedMessage id={'containers.type'} />,
    dataIndex: 'type',
    sorter: true,
  },
  {
    title: <FormattedMessage id={'containers.sacs-type'} />,
    dataIndex: 'sacsType',
    sorter: true,
  },
  {
    title: <FormattedMessage id={'containers.dressing-material'} />,
    dataIndex: 'dressingMaterial',
    sorter: true,
  },
  {
    title: '',
    render: Actions,
    className: 'actions',
  },
];
